import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";

import { cn } from "@/lib/utils";

export const AnimatedOverlay = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    data-anim="overlay"
    className={cn("fixed inset-0 z-50 bg-black/60 backdrop-blur-sm", className)}
    {...props}
  />
));
AnimatedOverlay.displayName = "AnimatedOverlay";

export function DialogCloseButton() {
  return (
    <DialogPrimitive.Close
      className={cn(
        "absolute right-4 top-4 rounded-sm text-muted-foreground opacity-70 transition-opacity",
        "hover:opacity-100 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
      )}
    >
      <X className="size-4" />
      <span className="sr-only">Schliessen</span>
    </DialogPrimitive.Close>
  );
}
